import React from "react";
import { X } from "lucide-react";
import Vacancy from "../previews/Vacancy";

    const VacancyPreviewModal = ({ isOpen, onClose, vacancyData, campaignData, selectedCompany   }) => {
  if (!isOpen) return null;



  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-card rounded-lg shadow-xl w-full max-w-6xl max-h-[95vh] overflow-hidden">
        <div className="flex items-center justify-between p-4 border-b border-border bg-card">
          <h2 className="text-xl font-semibold text-foreground"> </h2>
          <button
            onClick={onClose}
            className="text-muted-foreground hover:text-muted-foreground transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="overflow-y-auto max-h-[calc(95vh-80px)]">
          <Vacancy 
            vacancyData={vacancyData}
            campaignData={campaignData}
            isPreview={true}
            selectedCompany={selectedCompany}
          />
        </div>
      </div>
    </div>
  );
};

export default VacancyPreviewModal;
